export default __webpack_public_path__ + "static/media/moving.aec4c1aa.png";